import Avatar from "@mui/material/Avatar";
import ThumbDownIcon from "@mui/icons-material/ThumbDownOffAlt";
import ThumbUpIcon from "@mui/icons-material/ThumbUpOffAlt";
import React, { useContext, useEffect, useState, useRef } from "react";
import RateReviewIcon from "@mui/icons-material/RateReview";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import dateFormat from "dateformat";
import FavoriteIcon from "@mui/icons-material/Favorite";
import BookmarkRemoveIcon from '@mui/icons-material/BookmarkRemove';
import { useParams } from "react-router-dom";
import ENDPOINT from "../../../data/ENDPOINT";
import { Offcanvas, Toast } from "react-bootstrap";
import { Link } from "react-router-dom";
import logo from "../../../assets/smimage.png";
import { Chip } from "@material-ui/core";
import axios from "axios";
import Tooltip from "@mui/material/Tooltip";
import ShareIcon from "@mui/icons-material/Share";
import { AuthContext } from "../../../context/AuthContext";
import SetPage from "../../../data/SetPage";
import { Rating, Skeleton } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";

import ProjectSubmit from "./ProjectSubmit";

import ModalStyle from "../../../data/ModalStyle";
import Close from "@mui/icons-material/Close";


import BookmarkIcon from '@mui/icons-material/Bookmark';
import SubmitClassFeedback from "../../../actions/course/SubmitClassFeedback";

import DetectDevice from "../../../data/DetectDevice";
import SocialShare from "../../../components/SocialShare";

import DeleteIcon from "@mui/icons-material/Delete";
import SecurityHeaders from "../../../data/SecurityHeaders";

import DownloadIcon from "@mui/icons-material/Download";

import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import ClearIcon from '@mui/icons-material/Clear';

import ClassNotes from "../../../components/ClassNotes";

import {
  PlayArrow,
  Pause,
  VolumeUp,
  VolumeOff,
  Fullscreen,
  FullscreenExit,
  PictureInPictureAlt,
} from "@mui/icons-material";

import IconButton from '@mui/material/IconButton';
import { Slider, Stack } from "@mui/material";
import Crop169 from "@mui/icons-material/Crop169"; // 16:9 mode icon
import CropOriginal from "@mui/icons-material/CropOriginal"; // Exit cinematic icon
import { useMediaQuery } from "@mui/material";
import FastForwardIcon from "@mui/icons-material/FastForward";
import FastRewindIcon from "@mui/icons-material/FastRewind";
import { MenuIcon } from "lucide-react";



const Recordings = ({ props }) => {
  const params = useParams();
  const videoid = params.videoid;
  const batchid = params.batch_id;
  const courseurl = params.course_url;
  const { user } = useContext(AuthContext);

  const [read, setread] = useState(false);
  const [currentduration, setcurrentduration] = useState(null);
  const [currenttopic, setcurrenttopic] = useState(null);
  const [currenttopicid, setcurrenttopicid] = useState(null);
  const [suggestions, setsuggestions] = useState(null);
  const [videos, setvideos] = useState(null);
  const [tags, settags] = useState(null);
  const [videDuration, setVideoDuration] = useState(null);
  const [toastmessage, settoastmessage] = useState(null);
  const [previousclasses, setpreviousclasses] = useState(null);
  const [toast, settoast] = useState(false);
  const [submitting, setsubmitting] = useState(false);
  const [loading, setloading] = useState(true);
  const [classid, setclassid] = useState(null);
  const [modal, setmodal] = useState(false);
  const [value, setValue] = useState(null);
  const [review, setreview] = useState(null);
  const [sharemodal, setsharemodal] = useState(false);
  const [savedVideosModal, setSavedVideosModal] = useState(false);
  const [savedVideos, setSavedVideos] = useState([]);
  const [dbReady, setDbReady] = useState(false);
  const device = DetectDevice();
  const [path, setpath] = useState(null);

  const [notesDis, setNotesDis] = useState(false)

  const videoRef = useRef(null);
  const lastSentSecondRef = useRef(null);
  const dbRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);
  const [submitisHovered, setsubmitIsHovered] = useState(false);
  const [downloadisHovered, downloadsetIsHovered] = useState(false);
  const [savedisHovered, savedsetIsHovered] = useState(false);
  const [hoveredShareIndex, setHoveredShareIndex] = useState(null);
  const [hoveredFeedbackIndex, setHoveredFeedbackIndex] = useState(null);
  const [hoveredDownloadIndex, setHoveredDownloadIndex] = useState(null);
  const [showSaved, setShowSaved] = useState(false);
  const [downloadProgress, setDownloadProgress] = useState({}); // { [videoId]: percent }

  const [isPlaying, setIsPlaying] = useState(false);
  const [muted, setMuted] = useState(false);
  const [volume, setVolume] = useState(1);
  const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const [playbackRate, setPlaybackRate] = useState(1);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [showControls, setShowControls] = useState(true);
  const [cinematicMode, setCinematicMode] = useState(false);

  let inactivityTimer = useRef(null);
  const isMobile = useMediaQuery("(max-width:768px)");
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const [isLocked, setIsLocked] = useState(false);
  const devtoolsOpenRef = useRef(false);
  const isPiPActiveRef = useRef(false);
  const suspiciousActivityRef = useRef(false);
  const initialCheckDoneRef = useRef(false);

  const detectDeviceToolbar = () => {

    // ✅ NEVER run this detection on mobile
    if (isMobile) return false;
  
    const widthDiff = Math.abs(window.outerWidth - window.innerWidth);
    const heightDiff = Math.abs(window.outerHeight - window.innerHeight);
  
    const suspiciousSize =
      widthDiff < 100 && heightDiff < 100;
  
    const suspiciousDPR =
      window.devicePixelRatio > 2.5;
  
    const hasTouchButDesktop =
      "ontouchstart" in window &&
      navigator.maxTouchPoints > 0;
  
    return (
      (suspiciousSize && suspiciousDPR) ||
      (hasTouchButDesktop && suspiciousSize)
    );
  };

  const lockVideo = () => {

    const video = videoRef.current;
  
    if (!video) return;
  
    // already locked
    if (suspiciousActivityRef.current) return;
  
    suspiciousActivityRef.current = true;
  
    setIsLocked(true);
  
    settoastmessage("⚠️ Suspicious activity detected");
    settoast(true);
  
    // HARD STOP
    video.pause();
  
    // FORCE STOP
    video.currentTime = video.currentTime;
  
    // BLOCK UI
    video.controls = false;
  
    // BLUR
    video.style.filter = "blur(30px)";
    video.style.pointerEvents = "none";
  
  };

  const forceExitPiPAndLock = async () => {
    const video = videoRef.current;
    if (!video) return;
  
    try {
      if (document.pictureInPictureElement) {
        await document.exitPictureInPicture();
      }
    } catch (e) {
      console.log("PiP exit error", e);
    }
  
    // 🔒 Lock video
    lockVideo();
  };

//main useeffect for anti-cheat and tab switch handling, also PiP handling and devtools detection
  useEffect(() => {
    const video = videoRef.current;
  
// 🎬 PICTURE-IN-PICTURE HANDLING
const videoEl = videoRef.current;

if (videoEl) {
  videoEl.addEventListener("enterpictureinpicture", () => {
    console.log("Entered PiP");

    isPiPActiveRef.current = true;
  });

  videoEl.addEventListener("leavepictureinpicture", () => {
    console.log("Exited PiP");

    isPiPActiveRef.current = false;
  });
}



  
    // TAB SWITCH
    const handleVisibilityChange = () => {

      if (document.hidden) {
    
        if (isPiPActiveRef.current) {
          forceExitPiPAndLock();
        } else {
          lockVideo();
        }
    
      } else {
    
        if (!devtoolsOpenRef.current) {
          unlockVideo();
        }
    
      }
    };
    
    document.addEventListener(
      "visibilitychange",
      handleVisibilityChange
    );
  
    // ALT+TAB
    window.addEventListener("blur", () => {
      if (isPiPActiveRef.current) {
        forceExitPiPAndLock(); // 🔥 KEY FIX
      } else {
        lockVideo();
      }
    });


  
    // FULLSCREEN EXIT
    document.addEventListener("fullscreenchange", () => {

      if (!document.fullscreenElement) {
    
        setIsFullScreen(false);
    
      } else {
    
        setIsFullScreen(true);
    
        // ✅ Remove accidental blur on mobile fullscreen
        if (isMobile) {
    
          setIsLocked(false);
    
          const video = videoRef.current;
    
          if (video) {
            video.style.filter = "none";
            video.style.pointerEvents = "auto";
          }
        }
      }
    });
  

    const checkDevTools = () => {
// ✅ Skip aggressive devtools detection on mobile fullscreen
if (isMobile && document.fullscreenElement) {
  return;
}

const threshold = 160;

const widthDiff =
  window.outerWidth - window.innerWidth;

const heightDiff =
  window.outerHeight - window.innerHeight;

const isDevToolsOpen =
  widthDiff > threshold ||
  heightDiff > threshold;
    
      // ✅ NEW DETECTION
      const isDeviceToolbar = detectDeviceToolbar();
    
      if (isDevToolsOpen || isDeviceToolbar) {
        if (!devtoolsOpenRef.current) {
          devtoolsOpenRef.current = true;
    
          if (isPiPActiveRef.current) {
            forceExitPiPAndLock();
          } else {
            lockVideo();
          }
        }
      } else {
        if (devtoolsOpenRef.current) {
          devtoolsOpenRef.current = false;
          unlockVideo();
        }
      }
    };

    

const interval = setInterval(checkDevTools, 1000);

return () => {

  clearInterval(interval);

  document.removeEventListener(
    "visibilitychange",
    handleVisibilityChange
  );

};

  
  }, []);

  useEffect(() => {
    const handleKey = (e) => {
      // Ctrl+Shift+I OR Ctrl+Shift+M
      if (
        e.ctrlKey &&
        e.shiftKey &&
        (e.key.toLowerCase() === "i" || e.key.toLowerCase() === "m")
      ) {
        e.preventDefault();
  
        if (isPiPActiveRef.current) {
          forceExitPiPAndLock();
        } else {
          lockVideo();
        }
      }
    };
  
    window.addEventListener("keydown", handleKey);
  
    return () => window.removeEventListener("keydown", handleKey);
  }, []);

  useEffect(() => {

    if (initialCheckDoneRef.current) return;
  
    initialCheckDoneRef.current = true;
  
    const startupCheck = () => {
  
      const threshold = 160;
  
      const widthDiff =
        window.outerWidth - window.innerWidth;
  
      const heightDiff =
        window.outerHeight - window.innerHeight;
  
      const isDevToolsOpen =
        widthDiff > threshold ||
        heightDiff > threshold;
  
      const isDeviceToolbar =
        detectDeviceToolbar();
  
      // 🔥 IMMEDIATE LOCK ON PAGE LOAD
      if (
        document.hidden ||
        isDevToolsOpen ||
        isDeviceToolbar
      ) {
  
        devtoolsOpenRef.current = true;
  
        lockVideo();
  
      }
  
    };
  
    // run instantly
    startupCheck();
  
    // run again after browser stabilizes
    setTimeout(startupCheck, 500);
  
  }, []);

  useEffect(() => {
    const handleResize = () => {

      // ✅ Ignore resize while mobile fullscreen
      if (isMobile && document.fullscreenElement) {
        return;
      }
    
      const isDeviceToolbar = detectDeviceToolbar();
    
      if (isDeviceToolbar) {
    
        devtoolsOpenRef.current = true;
    
        if (isPiPActiveRef.current) {
          forceExitPiPAndLock();
        } else {
          lockVideo();
        }
    
      }
    };
  
    window.addEventListener("resize", handleResize);
  
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {

    const video = videoRef.current;
  
    if (!video) return;
  
    const preventPlayWhileLocked = () => {
  
      if (
        isLocked ||
        suspiciousActivityRef.current
      ) {
  
        video.pause();
  
        video.style.filter = "blur(30px)";
        video.style.pointerEvents = "none";
      }
    };
  
    video.addEventListener(
      "play",
      preventPlayWhileLocked
    );
  
    return () => {
      video.removeEventListener(
        "play",
        preventPlayWhileLocked
      );
    };
  
  }, [isLocked]);

  useEffect(() => {

    const video = videoRef.current;
  
    if (!video) return;
  
    const blockPlayback = () => {
  
      if (
        isLocked ||
        suspiciousActivityRef.current
      ) {
  
        video.pause();
  
        video.controls = false;
  
        video.style.filter = "blur(30px)";
        video.style.pointerEvents = "none";
      }
    };
  
    // continuously block playback
    video.addEventListener("play", blockPlayback);
  
    const interval = setInterval(() => {
  
      if (
        isLocked ||
        suspiciousActivityRef.current
      ) {
  
        if (!video.paused) {
          video.pause();
        }
  
        video.controls = false;
  
        video.style.filter = "blur(30px)";
        video.style.pointerEvents = "none";
      }
  
    }, 200);
  
    return () => {
  
      video.removeEventListener(
        "play",
        blockPlayback
      );
  
      clearInterval(interval);
    };
  
  }, [isLocked]);

  const unlockVideo = () => {

    const video = videoRef.current;
  
    if (!video) return;
  
    suspiciousActivityRef.current = false;
  
    setIsLocked(false);
  
    video.controls = true;
  
    video.style.filter = "none";
    video.style.pointerEvents = "auto";
  
  };



  const togglePlayPause = () => {

    // 🔒 BLOCK PLAY DURING RECORDING
    if (
      isLocked ||
      suspiciousActivityRef.current
    ) {
  
      const video = videoRef.current;
  
      if (video) {
        video.pause();
  
        video.style.filter = "blur(30px)";
        video.style.pointerEvents = "none";
      }
  
      return;
    }
  
    const video = videoRef.current;
  
    if (video.paused) {
      video.play();
      setIsPlaying(true);
    } else {
      video.pause();
      setIsPlaying(false);
    }
  };

  const toggleMute = () => {
    const video = videoRef.current;
    video.muted = !video.muted;
    setMuted(video.muted);
  };

  const handleVolumeChange = (e) => {
    const newVolume = parseFloat(e.target.value);
    videoRef.current.volume = newVolume;
    setVolume(newVolume);
    setMuted(newVolume === 0);
  };

  const handleTimeUpdate = () => {
    setCurrentTime(videoRef.current.currentTime);
  };

  const handleLoadedMetadata = () => {
    setDuration(videoRef.current.duration);
  };

  const handleSeek = (e) => {
    if (isLocked) return;
  
    const time = parseFloat(e.target.value);
    videoRef.current.currentTime = time;
    setCurrentTime(time);
  };

  const toggleFullscreen = async () => {
    const video = videoRef.current;

    if (!document.fullscreenElement) {
      try {
        await video.parentElement.requestFullscreen();

        // Lock orientation if supported (mostly Android)
        if (
          typeof window !== "undefined" &&
          window.screen.orientation &&
          window.screen.orientation.lock
        ) {
          try {
            await window.screen.orientation.lock("landscape");
          } catch (err) {
            console.warn("Orientation lock failed:", err);
          }
        }

        setIsFullScreen(true);
      } catch (err) {
        console.warn("Fullscreen request failed:", err);
      }
    } else {
      try {
        await document.exitFullscreen();
        setIsFullScreen(false);

        // Try unlocking orientation
        if (
          window.screen.orientation &&
          window.screen.orientation.unlock
        ) {
          window.screen.orientation.unlock();
        }
      } catch (err) {
        console.warn("Exiting fullscreen failed:", err);
      }
    }
  };



  const enablePiP = async () => {
    try {
      await videoRef.current.requestPictureInPicture();
    } catch (error) {
      console.log("PiP not supported", error);
    }
  };

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes < 10 ? "0" : ""}${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };



  const toggleSaved = () => {
    setShowSaved((prev) => !prev);
  };

  // Initialize IndexedDB
  useEffect(() => {
    const dbPromise = indexedDB.open("VideoStorage", 1);

    dbPromise.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains("videos")) {
        db.createObjectStore("videos", { keyPath: "id" });
      }
    };

    dbPromise.onsuccess = (event) => {
      dbRef.current = event.target.result;
      setDbReady(true);
      loadSavedVideos();
    };

    dbPromise.onerror = (event) => {
      settoastmessage("Failed to open video storage: " + event.target.error);
      settoast(true);
    };

    return () => {
      if (dbRef.current) {
        dbRef.current.close();
      }
    };
  }, []);
  useEffect(() => {
    if (dbReady) {
      loadSavedVideos();
    }
  }, [dbReady]);
  // Save video to IndexedDB
  const saveVideo = async (videos) => {
    if (!videos || !videos.recording || !dbReady || !user.SessionId) {
      settoastmessage("Cannot save video: Missing data or storage not ready");
      settoast(true);
      return;
    }
    setHoveredDownloadIndex(videos.id);

    setsubmitting(true);
    setDownloadProgress((prev) => ({ ...prev, [videos.id]: 0 }));
    settoastmessage("Downloading video...");
    settoast(true);

    try {
      const formData = new FormData();
      formData.append("session", user.SessionId);
      formData.append("video_id", videos.id);
      formData.append("batch_id", batchid);

      const xhr = new XMLHttpRequest();

      xhr.open("POST", `${ENDPOINT}get-video-blob.php`, true);
      xhr.responseType = "blob";

      xhr.upload.onerror = () => {
        settoastmessage("Upload error");
        settoast(true);
        setsubmitting(false);
        setDownloadProgress((prev) => ({ ...prev, [videos.id]: null }));
      };

      setHoveredDownloadIndex(false);

      xhr.onprogress = (event) => {
        if (event.lengthComputable) {
          const percent = Math.round((event.loaded / event.total) * 100);
          setDownloadProgress((prev) => ({ ...prev, [videos.id]: percent }));
        }
      };

      xhr.onload = () => {
        if (xhr.status !== 200) {
          settoastmessage("Server error: " + xhr.status);
          settoast(true);
          setsubmitting(false);
          setDownloadProgress((prev) => ({ ...prev, [videos.id]: null }));
          return;
        }

        const blob = xhr.response;

        const videoId = videos.id;
        const transaction = dbRef.current.transaction(["videos"], "readwrite");
        const store = transaction.objectStore("videos");

        const checkRequest = store.get(videoId);
        checkRequest.onsuccess = () => {
          if (checkRequest.result) {
            settoastmessage("Video already saved");
            settoast(true);
            setsubmitting(false);
            setDownloadProgress((prev) => ({ ...prev, [videos.id]: null }));
            return;
          }

          store.put({
            id: videoId,
            data: blob,
            title: videos.class_title,
            cover_pic: videos.cover_pic,
            class_starts: videos.class_starts,
            class_ends: videos.class_ends,
            class_description: videos.class_description,
            savedAt: new Date(),
          });

          transaction.oncomplete = () => {
            settoastmessage("Video saved successfully!");
            settoast(true);
            setsubmitting(false);
            setDownloadProgress((prev) => ({ ...prev, [videos.id]: null }));
            loadSavedVideos();
          };
          transaction.onerror = () => {
            settoastmessage("Failed to save video: " + transaction.error);
            settoast(true);
            setsubmitting(false);
            setDownloadProgress((prev) => ({ ...prev, [videos.id]: null }));
          };
        };
      };

      xhr.onerror = () => {
        settoastmessage("Failed to download video.");
        settoast(true);
        setsubmitting(false);
        setDownloadProgress((prev) => ({ ...prev, [videos.id]: null }));
      };

      xhr.send(formData);
    } catch (error) {
      setHoveredDownloadIndex(false);
      settoastmessage("Unexpected error: " + error.message);
      settoast(true);
      setsubmitting(false);
      setDownloadProgress((prev) => ({ ...prev, [videos.id]: null }));
    }
  };


  // Load saved videos from IndexedDB
  const loadSavedVideos = async () => {
    if (!dbReady || !dbRef.current) return;

    try {
      const transaction = dbRef.current.transaction(["videos"], "readonly");
      const store = transaction.objectStore("videos");
      const request = store.getAll();

      request.onsuccess = () => {
        setSavedVideos(request.result);
      };
      request.onerror = () => {
        settoastmessage("Failed to load saved videos: " + request.error);
        settoast(true);
      };
    } catch (error) {
      settoastmessage("Error accessing video storage: " + error.message);
      settoast(true);
    }
  };

  // Play a saved video
  const playSavedVideo = async (videoId) => {
    if (!dbReady || !dbRef.current) {
      settoastmessage("Video storage not ready");
      settoast(true);
      return;
    }

    try {
      const transaction = dbRef.current.transaction(["videos"], "readonly");
      const store = transaction.objectStore("videos");
      const request = store.get(videoId);

      request.onsuccess = () => {
        const video = request.result;
        if (video && video.data) {
          const videoPlayer = document.getElementById("videoplayer");
          const blobUrl = URL.createObjectURL(video.data);
          videoPlayer.src = blobUrl;
          videoPlayer.play();
          videoPlayer.onended = () => URL.revokeObjectURL(blobUrl);
          setSavedVideosModal(false);

          // Update video title and description in UI
          setvideos((prev) => ({
            ...prev,
            class_title: video.title,
            class_description: video.class_description,
            recording: blobUrl,
            cover_pic: video.cover_pic,
            class_starts: video.class_starts,
            class_ends: video.class_ends,
          }));
        } else {
          settoastmessage("Video not found in storage");
          settoast(true);
        }
      };
      request.onerror = () => {
        settoastmessage("Failed to load video: " + request.error);
        settoast(true);
      };
    } catch (error) {
      settoastmessage("Error playing video: " + error.message);
      settoast(true);
    }
  };

  // Delete a saved video
  const deleteSavedVideo = async (videoId) => {
    if (!dbReady || !dbRef.current) {
      settoastmessage("Video storage not ready");
      settoast(true);
      return;
    }

    try {
      const transaction = dbRef.current.transaction(["videos"], "readwrite");
      const store = transaction.objectStore("videos");
      const request = store.delete(videoId);

      request.onsuccess = () => {
        settoastmessage("Video removed from saved list");
        settoast(true);
        loadSavedVideos();
      };
      request.onerror = () => {
        settoastmessage("Failed to delete video: " + request.error);
        settoast(true);
      };
    } catch (error) {
      settoastmessage("Error deleting video: " + error.message);
      settoast(true);
    }
  };

  // Update video duration
  const updateDuration = async (duration) => {
    if (!videoid || !user.SessionId) return;
    const formData = new FormData();
    formData.append("video_id", videoid);
    formData.append("duration", duration);
    formData.append("session", user.SessionId);
    // formData.append('csrf_token', csrfToken);

    try {
      await axios.post(`${ENDPOINT}update-video.php`, formData, {
        headers: { "content-type": "multipart/form-data" },
      });
    } catch (err) {
      settoastmessage("Error updating duration: " + err.message);
      settoast(true);
    }
  };

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleTimeUpdate = () => {
      const currentSec = Math.round(video.currentTime);
      setcurrentduration(currentSec);

      if (
        currentSec !== 0 &&
        currentSec % 10 === 0 &&
        lastSentSecondRef.current !== currentSec
      ) {
        lastSentSecondRef.current = currentSec;
        updateDuration(currentSec);
      }
    };

    video.addEventListener("timeupdate", handleTimeUpdate);

    return () => {
      video.removeEventListener("timeupdate", handleTimeUpdate);
    };
  }, [videoid, user.SessionId]);

  useEffect(() => {
    if (videos && videos.watch_duration && videoRef.current) {
      videoRef.current.currentTime = videos.watch_duration;
    }
  }, [videos]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currenttopic]);

  useEffect(() => {
    getvideos();
  }, [params.videoid]);
  const [courseId, setCourseId] = useState({
    video_id: '',
    course_id: '',
  });

  const getvideos = async () => {
    if (!user.SessionId) {
      settoastmessage("Cannot fetch videos: Missing session or CSRF token");
      settoast(true);
      setloading(false);
      return;
    }

    try {
      const response = await fetch(
        `${ENDPOINT}get-recording.php?id=${videoid}&session=${user.SessionId}&batch_id=${batchid}&course_url=${courseurl}`
      );
      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const result = await response.json();
      if (result.status === "error") {
        throw new Error(result.message);
      }
      setvideos(result.current_video);
      setCourseId({ ...courseId, video_id: result.current_video.id, course_id: result.current_video.course_id })
      setsuggestions(result.suggestions);
      setpreviousclasses(result.previous_classes);
      setVideoDuration(result.current_video.watch_duration);

      if (result.current_video.watch_duration) {
        const videoplayer = document.getElementById("videoplayer");
        if (videoplayer && result.current_video.watch_duration) {
          videoplayer.currentTime = result.current_video.watch_duration;
        }
      }

      settags(result.tags);
      if (
        result &&
        result.current_video &&
        !suspiciousActivityRef.current &&
        !isLocked
      ) {
      
        let videoplayer =
          document.getElementById("videoplayer");
      
        if (videoplayer) {
          videoplayer.play();
        }
      
      }
    } catch (error) {
      settoastmessage("Error fetching videos: " + error.message);
      settoast(true);
    } finally {
      setloading(false);
    }
  };

  useEffect(() => {
    document.addEventListener("contextmenu", (event) => {
      event.preventDefault();
    });
    getvideos();
  }, []);

  useEffect(() => {

    // 🔒 NEVER autoplay if locked
    if (
      suspiciousActivityRef.current ||
      isLocked
    ) {
      return;
    }
  
    const videoplayer =
      document.getElementById("videoplayer");
  
    if (videoplayer) {
      videoplayer.play();
    }
  
  }, [videos, isLocked]);

  const changetopic = (e) => {
    e.preventDefault();
    if (currenttopicid) {
      if (
        document
          .getElementById(currenttopicid)
          .classList.contains("video-active")
      ) {
        document
          .getElementById(currenttopicid)
          .classList.remove("video-active");
      }
    }
    setcurrenttopic(videos[e.currentTarget.id]);
    setcurrenttopicid(e.currentTarget.id);
    document.getElementById(e.currentTarget.id).classList.add("video-active");
  };

  const hovered = (e) => {
    const currentvideo = e.target.id;
    const video = document.getElementById(currentvideo);
    video.controls = true;
  };

  useEffect(() => {
    SetPage("Recordings");
  }, []);

  const addFavourite = async ({ vid, favid }) => {
    const formData = new FormData();
    formData.append("session", user.SessionId);
    // formData.append('csrf_token', csrfToken);
    formData.append("video_id", vid);

    try {
      const res = await axios.post(`${ENDPOINT}add-favourite.php`, formData, {
        headers: { "content-type": "multipart/form-data" },
      });
      if (res.data.status === "success") {
        const favitem = document.getElementById(favid);
        if (res.data.action === "liked") {
          favitem.classList.add("text-secondary", "text-danger");
          settoastmessage("Video added to favourites");
          settoast(true);
        } else if (res.data.action === "disliked") {
          settoastmessage("Video removed from favourites");
          favitem.classList.remove("text-danger");
          favitem.classList.add("text-secondary");
          settoast(true);
        }
      } else {
        settoastmessage("Error updating favourites: " + res.data.message);
        settoast(true);
      }
    } catch (error) {
      settoastmessage("Error updating favourites: " + error.message);
      settoast(true);
    }
  };

  const addWatchLater = async ({ vid, markid }) => {
    const formData = new FormData();
    formData.append("session", user.SessionId);
    // formData.append('csrf_token', csrfToken);

    formData.append("video_id", vid);

    try {
      const res = await axios.post(`${ENDPOINT}add-watch-later.php`, formData, {
        headers: { "content-type": "multipart/form-data" },
      });
      if (res.data.status === "success") {
        const markitem = document.getElementById(markid);
        if (res.data.action === "added") {
          settoastmessage("Video added to watch later");
          markitem.classList.remove("text-secondary");
          markitem.classList.add("text-primary");
          settoast(true);
        } else if (res.data.action === "removed") {
          settoastmessage("Video removed from watch later");
          markitem.classList.remove("text-primary");
          markitem.classList.add("text-secondary");
          settoast(true);
        }
      } else {
        settoastmessage("Error updating watch later: " + res.data.message);
        settoast(true);
      }
    } catch (error) {
      settoastmessage("Error updating watch later: " + error.message);
      settoast(true);
    }
  };

  const SubmitFeedback = async () => {
    // if (!csrfToken) {
    //   settoastmessage('Cannot submit feedback: Missing CSRF token');
    //   settoast(true);
    //   return;
    // }
    setsubmitting(true);
    const res = await SubmitClassFeedback({
      payload:
      {
        session: user.SessionId,
        // csrf_token: csrfToken,
        class_id: classid,
        review: review,
        rating: value,
        batch_id: batchid,
        course_url: courseurl,
      },
    });

    if (res) {
      setsubmitting(false);
      if (res.status === "success") {
        settoastmessage("Feedback submitted successfully");
        setmodal(false);
        getvideos();
        settoast(true);
      } else {
        settoastmessage("Something went wrong: " + res.message);
        settoast(true);
      }
    }
  };

  useEffect(() => {
    if (sharemodal === false) {
      setpath(null);
    }
  }, [sharemodal]);
  const checkSavedVideos = (id) => {
    return savedVideos.some((video) => video.id === id);
  }

  const skipForward = () => {
    if (videoRef.current) {
      videoRef.current.currentTime = Math.min(
        videoRef.current.currentTime + 30,
        videoRef.current.duration
      );
      setCurrentTime(videoRef.current.currentTime);
    }
  };

  const skipBackward = () => {
    if (videoRef.current) {
      videoRef.current.currentTime = Math.max(
        videoRef.current.currentTime - 30,
        0
      );
      setCurrentTime(videoRef.current.currentTime);
    }
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      // Only trigger if focus is not on an input or textarea
      const tag = document.activeElement.tagName.toLowerCase();
      if (tag === "input" || tag === "textarea") return;

      // Left arrow or 'A' key: rewind 30s
      if (e.key === "ArrowLeft" || e.key.toLowerCase() === "j" || e.key.toLowerCase() === "J") {
        skipBackward();
        e.preventDefault();
      }
      // Right arrow or 'D' key: forward 30s
      if (e.key === "ArrowRight" || e.key.toLowerCase() === "l" || e.key.toLowerCase() === "L") {
        skipForward();
        e.preventDefault();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [skipBackward, skipForward]);



  return (
    <>



      {/* Share Modal */}
      {device === "mobile" ? (
        <Offcanvas
          className="share-post-canvas"
          show={sharemodal}
          placement={"bottom"}
          onHide={() => {
            setpath(null);
            setsharemodal(false);
          }}
          {...props}
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Share Recording</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <SocialShare path={path} />
          </Offcanvas.Body>
        </Offcanvas>
      ) : (
        <Modal
          open={sharemodal}
          onClose={() => {
            setpath(null);
            setsharemodal(false);
          }}
        >
          <Box sx={ModalStyle} className="p-3 rounded">
            <div className="d-flex align-items-center justify-content-between">
              <Typography id="modal-modal-title" variant="h6" component="h2">
                Share Recording
              </Typography>
              <Close className="click" onClick={() => setsharemodal(false)} />
            </div>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              <SocialShare path={path} />
            </Typography>
          </Box>
        </Modal>
      )}

      <Modal open={savedVideosModal} onClose={() => setSavedVideosModal(false)}>
        <Box
          sx={ModalStyle}
          className="col-lg-6 p-3 col-md-5 col-sm-6 col-11 br-5"
        >
          <div className="modal-header">
            <h4>Saved Videos</h4>
            <Close
              className="click"
              onClick={() => setSavedVideosModal(false)}
            />
          </div>
          <hr />
          {dbReady && savedVideos.length > 0 ? (
            <ul>
              {savedVideos.map((video) => (
                <li key={video.id} className="d-flex   mb-3">
                  <div
                    type="button"
                    className="rec-suggestion rounded "
                    style={{ backgroundImage: `url(${video.cover_pic})` }}
                  >
                    <div
                      className="text-white"
                      onClick={() => playSavedVideo(video.id)}
                    >
                      <div className="suggestion-cover rounded flex-column d-flex align-items-center justify-content-center p-2">
                        <h6>{dateFormat(video.class_starts, "dS mmm")}</h6>
                        <hr className="mb-1" />
                        <div className="d-flex">
                          <p className="extra-small text-white mb-0">
                            {dateFormat(video.class_starts, "hh:mm tt")}
                          </p>
                          -
                          <p className="extra-small text-white mb-0">
                            {dateFormat(video.class_ends, "hh:mm tt")}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between align-items-center ms-2 mb-1">
                    <span
                      className="click h5 mb-0 pb-0"
                      onClick={() => playSavedVideo(video.id)}
                    >
                      {video.title}{" "}
                      <small>
                        ({dateFormat(video.savedAt, "dS mmm yyyy")})
                      </small>
                    </span>
                    <DeleteIcon
                      className="click ms-2 "
                      onClick={() => deleteSavedVideo(video.id)}
                    />
                  </div>
                  {/* Display video preview */}
                </li>
              ))}
            </ul>
          ) : dbReady ? (
            <p>No videos saved yet.</p>
          ) : (
            <p>Loading video storage...</p>
          )}
        </Box>
      </Modal>

      {/* Feedback Modal */}
      <Modal open={modal} onClose={() => setmodal(false)}>
        <Box
          sx={ModalStyle}
          className="col-lg-4 p-3 col-md-5 col-sm-6 col-11 br-5"
        >
          <div className="modal-header">
            <h4>Submit Class Feedback</h4>
            <Close className="click" onClick={() => setmodal(false)} />
          </div>
          <hr />
          <p className="mb-3">
            {parseInt(value) === 1
              ? "Poor"
              : parseInt(value) === 2
                ? "Below Average"
                : parseInt(value) === 3
                  ? "Average"
                  : parseInt(value) === 4
                    ? "Good"
                    : parseInt(value) === 5
                      ? "Excellent"
                      : ""}
          </p>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              SubmitFeedback();
            }}
          >
            <input
              value={review}
              onChange={(e) => setreview(e.target.value)}
              className="mt-3 mb-3 w-100 form-control"
              placeholder="Write your feedback"
            />
            <Rating
              size="large"
              name="simple-controlled"
              value={value}
              onChange={(event, newValue) => {
                setValue(newValue);
              }}
            />
            <button
              className="btn mt-4 btn-primary btn-sm w-100"
              disabled={submitting}
            >
              {submitting ? "Submitting..." : "Submit Class Feedback"}
            </button>
          </form>
        </Box>
      </Modal>

      <div className="container-fluid position-fixed bottom-60 left-0 justify-center">
        <Toast
          className="bg-warning"
          show={toast}
          delay={6000}
          autohide
          onClose={() => settoast(false)}
        >
          <Toast.Header className="bg-warning">
            <img
              src="holder.js/20x20?text=%20"
              className="rounded me-2"
              alt=""
            />
            <strong className="me-auto">{toastmessage}</strong>
          </Toast.Header>
        </Toast>
      </div>

      <div className="video-page">
        <div className="container-fluid mt-20 mt-0 p-0 p-lg-3 pt-lg-0 d-flex flex-wrap">
          <div className={`col-12 card shadow mb-3 rounded-3 ${cinematicMode ? 'mx-auto' : 'col-lg-8 col-md-12 col-sm-12'}`}>
            <div style={{ position: "relative", display: "inline-block" }}>
              <div
                className="position-relative bg-black rounded  mx-auto w-0 "
                onMouseMove={() => {
                  setShowControls(true);
                  clearTimeout(inactivityTimer.current);
                  inactivityTimer.current = setTimeout(() => setShowControls(false), 3000);
                }}
                sx={{
                  width: cinematicMode ? '50vw' : '95%',
                  maxWidth: cinematicMode ? '800px' : '95%',
                  transition: 'width 0.4s ease, max-width 0.4s ease',
                  margin: cinematicMode ? '0 auto' : '0',
                }}

              >
                 <video
                  id="videoplayer"
                  ref={videoRef}
                
                  src={videos && videos.recording}
                  className="w-100 "
                  onTimeUpdate={handleTimeUpdate}
                  onLoadedMetadata={handleLoadedMetadata}
                  onClick={(e) => {
                    if (isLocked) {
                      e.preventDefault();
                      e.stopPropagation();
                      return;
                    }
                    togglePlayPause();
                  }}
                  controlsList="nodownload"
                  muted={muted}
                  playbackRate={playbackRate}
                  style={{
                    pointerEvents: isLocked ? "none" : "auto",
                    filter:
                    isLocked && !isFullScreen
                      ? "blur(25px)"
                      : "none",
                    borderRadius: "12px",
                    width: isFullScreen ? "100vw" : "100%",
                    height: isFullScreen ? "100vh" : "auto",
                    objectFit: "contain",
                    backgroundColor: "black", // optional
                  }}
                  playsInline={!isIOS}
                />


                {showControls && (
                  <Box
                    className="position-absolute bottom-0 start-0 end-0"
                    sx={{
                      background: "linear-gradient(to top, rgba(0,0,0,0.75), rgba(0,0,0,0))",
                      px: 3,
                      py: 2,
                      borderBottomLeftRadius: "12px",
                      borderBottomRightRadius: "12px",
                      transition: "opacity 0.3s ease-in-out",
                    }}
                  >
                    {/* Seek Bar */}
                    <Slider
                      value={currentTime}
                      min={0}
                      max={duration}
                      step={0.1}
                      onChange={(e, val) => handleSeek({ target: { value: val } })}
                      sx={{
                        color: "#fff",
                        '& .MuiSlider-thumb': { width: 12, height: 12 },
                        '& .MuiSlider-track': { height: 6 },
                        '& .MuiSlider-rail': { height: 6, opacity: 0.3 },
                        mb: 0,
                        margindown: "-100px",
                      }}
                      style={{ marginBottom: "-15px", width: "98%", marginLeft: 10 }}
                    />

                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                      {/* Left Controls */}
                      <Stack direction="row" alignItems="center" spacing={2}>
                        {/* Rewind 30s */}
                        <IconButton onClick={skipBackward} size="medium" title="Rewind 30s">
                          <FastRewindIcon sx={{ color: "#fff", fontSize: 24 }} />
                        </IconButton>

                        {/* Pause/Play */}
                        <IconButton onClick={togglePlayPause} size="medium">
                          {isPlaying ? (
                            <Pause sx={{ color: "#fff", fontSize: 30 }} />

                          ) : (
                            <PlayArrow sx={{ color: "#fff", fontSize: 30 }} />

                          )}
                        </IconButton>

                        {/* Forward 30s */}
                        <IconButton onClick={skipForward} size="medium" title="Forward 30s">
                          <FastForwardIcon sx={{ color: "#fff", fontSize: 24 }} />
                        </IconButton>

                        {/* Desktop-only controls */}
                        {!isMobile && (
                          <>
                            <IconButton onClick={toggleMute} size="medium">
                              {muted || volume === 0 ? (
                                <VolumeOff sx={{ color: "#fff", fontSize: 24 }} />
                              ) : (
                                <VolumeUp sx={{ color: "#fff", fontSize: 24 }} />
                              )}
                            </IconButton>

                            <Slider
                              value={volume}
                              min={0}
                              max={1}
                              step={0.01}
                              onChange={handleVolumeChange}
                              sx={{
                                width: 100,
                                color: "#fff",
                                '& .MuiSlider-thumb': { width: 10, height: 10 },
                                '& .MuiSlider-track': { height: 4 },
                                '& .MuiSlider-rail': { height: 4 },
                              }}
                            />

                            <Typography sx={{ color: "#fff", fontSize: 14 }}>
                              {formatTime(currentTime)} / {formatTime(duration)}
                            </Typography>
                          </>
                        )}
                      </Stack>


                      {/* Right Controls */}
                      <Stack direction="row" alignItems="center" spacing={2}>

                        {/* Always Show - Playback Speed Dropdown */}
                        <Box sx={{ color: "#fff", fontSize: 14 }}>
                          <select
                            value={playbackRate}
                            onChange={(e) => {
                              const rate = parseFloat(e.target.value);
                              setPlaybackRate(rate);
                              if (videoRef.current) {
                                videoRef.current.playbackRate = rate;
                              }
                            }}
                            style={{
                              background: "transparent",
                              color: "#fff",
                              border: "1px solid #fff",
                              borderRadius: "4px",
                              padding: "4px 8px",
                              fontSize: "14px",
                              appearance: "none",
                            }}
                          >
                            {[0.5, 1, 1.25, 1.5, 2].map((rate) => (
                              <option key={rate} value={rate} style={{ color: "#000" }}>
                                {rate}x
                              </option>
                            ))}
                          </select>
                        </Box>

                        {/* Desktop Only - Picture-in-Picture */}
                        {!isMobile && (
                          <Tooltip title="Picture-in-Picture">
                            <IconButton onClick={enablePiP} size="medium">
                              <PictureInPictureAlt sx={{ color: "#fff" }} />
                            </IconButton>
                          </Tooltip>
                        )}

                        {/* Desktop Only - Cinematic Mode Toggle */}
                        {!isMobile && (
                          <Tooltip title={cinematicMode ? "Exit Cinematic View" : "Cinematic View"}>
                            <IconButton onClick={() => setCinematicMode(!cinematicMode)} size="medium">
                              {cinematicMode ? (
                                <CropOriginal sx={{ color: "#fff" }} />
                              ) : (
                                <Crop169 sx={{ color: "#fff" }} />
                              )}
                            </IconButton>
                          </Tooltip>
                        )}

                        {/* Always Show - Fullscreen Toggle */}
                        <Tooltip title="Fullscreen">
                          <IconButton onClick={toggleFullscreen} size="medium">
                            {isFullScreen ? (
                              <FullscreenExit sx={{ color: "#fff" }} />
                            ) : (
                              <Fullscreen sx={{ color: "#fff" }} />
                            )}
                          </IconButton>
                        </Tooltip>

                      </Stack>

                    </Stack>
                  </Box>
                )}
              </div>

              <img
                src={logo}
                alt="Watermark"
                style={{
                  position: "absolute",
                  bottom: "20px",
                  right: "15px",
                  width: "200px",
                  opacity: 0.5,
                  pointerEvents: "none",
                }}
                className="rounded"
              />
            </div>

            <div className="flex current-video lg-mb-20 mt-2 sm-mb-0">
              <div className="video-data w-100 mx-3 mb-3">
                <h5 className="sm-18 card-title">
                  {videos ? videos.class_title : ""}
                </h5>
                <p className="sm-12 truncate truncate3">
                  {videos && videos.class_description !== "null" ? (
                    videos.class_description
                  ) : (
                    <></>
                  )}
                </p>
                <hr className="my-2" />
                {videos && videos.class_starts ? (
                  <div className="flex w-100 justify-content-between align-items-center">
                    <div className="d-flex flex-wrap w-100 justify-content-between">
                      <div className="d-flex col-lg-6 col-md-6 col-12">
                        <div className="mr-15">
                          <div className="sm-text-small d-flex flex-row  flex-lg-column flex-xl-row">
                            <b>Date : </b>
                            <p>
                              {dateFormat(
                                videos ? videos.class_starts : null,
                                "dS mmm yyyy"
                              )}
                            </p>
                          </div>
                        </div>
                        <div className="sm-text-small d-flex  d-flex flex-row  flex-lg-column flex-xl-row ">
                          <b>Batch : </b>
                          <p>
                            {dateFormat(
                              videos ? videos.class_starts : null,
                              "hh:mm tt"
                            )}{" "}
                            -{" "}
                            {dateFormat(
                              videos ? videos.class_ends : null,
                              "hh:mm tt"
                            )}
                          </p>
                        </div>
                      </div>

                      <div className="d-flex col-lg-6 col-md-6 col-12 align-items-start justify-content-evenly justify-content-lg-end flex-wrap">
                        <div className="mt-3 mt-lg-1 px-1">

                          <button
                            onClick={() => setsharemodal(true)}
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "50%",
                              border: "1px solid #fe6f35",
                              backgroundColor: isHovered
                                ? "#fe6f35"
                                : "transparent",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              padding: "0",
                              cursor: "pointer",
                              transition: "background-color 0.3s ease",
                            }}
                          >
                            <ShareIcon
                              style={{
                                fontSize: "18px",
                                color: isHovered ? "#fff" : "#fe6f35",
                                transition: "color 0.3s ease",
                              }}
                            />
                          </button>


                        </div>

                        <div className="mt-3 mt-lg-1 px-1">
                          <button
                            onClick={() => {
                              setclassid(videos.id);
                              setmodal(true);
                            }}
                            onMouseEnter={() => setsubmitIsHovered(true)}
                            onMouseLeave={() => setsubmitIsHovered(false)}
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "50%",
                              border: "1px solid #fe6f35",
                              backgroundColor: submitisHovered
                                ? "#fe6f35"
                                : "transparent",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              padding: "0",
                              cursor: "pointer",
                              transition: "background-color 0.3s ease",
                            }}
                          >
                            <RateReviewIcon
                              style={{
                                fontSize: "18px",
                                color: submitisHovered ? "#fff" : "#fe6f35",
                                transition: "color 0.3s ease",
                              }}
                            />
                          </button>
                        </div>

                        <div className="mt-3 mt-lg-1 d-flex align-items-center justify-content-start px-1">

                          {
                            savedVideos &&

                              checkSavedVideos(videos.id) ? (
                              <button
                                onClick={() => deleteSavedVideo(videos.id)}

                                style={{
                                  width: "40px",
                                  height: "40px",
                                  borderRadius: "50%",
                                  border: "1px solid rgb(16, 17, 18)",
                                  backgroundColor: "#fe6f35",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  padding: "0",
                                  cursor: "pointer",
                                  transition: "background-color 0.3s ease",
                                }}
                              >
                                <BookmarkRemoveIcon
                                  style={{
                                    fontSize: "18px",
                                    color: "#fff",
                                    transition: "color 0.3s ease",
                                  }}
                                />
                              </button>) : (
                              <button
                                className="btn"
                                style={{
                                  width: "40px",
                                  height: "40px",
                                  borderRadius: "50%",
                                  border: "1px solid #d1d5db", // light gray border
                                  backgroundColor: hoveredDownloadIndex == videos.id ? "#111827" : "#f9fafb", // dark on hover, light on normal
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  padding: "0",
                                  cursor: submitting ? "not-allowed" : "pointer",
                                  position: "relative",
                                  transition: "background-color 0.3s, border-color 0.3s",
                                  boxShadow: hoveredDownloadIndex == videos.id ? "0 2px 8px rgba(0,0,0,0.08)" : "none"
                                }}
                                onClick={!submitting ? () => { saveVideo(videos); } : undefined}
                                onMouseEnter={() => setHoveredDownloadIndex(videos.id)}
                                onMouseLeave={() => setHoveredDownloadIndex(false)}
                                disabled={submitting}
                              >
                                {submitting && downloadProgress[videos.id] !== undefined && downloadProgress[videos.id] !== null ? (
                                  <span
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: "bold",
                                      color: "#fe6f35", // Apple green
                                    }}
                                    className="text-success"

                                  >
                                    {downloadProgress[videos.id]}%
                                  </span>
                                ) : (
                                  <DownloadIcon
                                    style={{
                                      color: hoveredDownloadIndex == videos.id ? "#f9fafb" : "#111827", // white on hover, dark on normal
                                      fontSize: "20px",
                                      transition: "color 0.3s"
                                    }}
                                  />
                                )}
                              </button>)}
                        </div>

                        <div className="mt-3 mt-lg-1 d-flex align-items-center justify-content-start px-1">
                          <button
                            onClick={() => setSavedVideosModal(true)}
                            onMouseEnter={() => savedsetIsHovered(true)}
                            onMouseLeave={() => savedsetIsHovered(false)}
                            disabled={!dbReady}
                            className="btn"
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "50%",
                              border: "1px solid #fe6f35",
                              backgroundColor: savedisHovered
                                ? "#fe6f35"
                                : "transparent",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              padding: "0",
                              cursor: dbReady ? "pointer" : "not-allowed",
                              opacity: dbReady ? 1 : 0.6,
                              transition: "background-color 0.3s ease",
                            }}
                          >
                            <VideoLibraryIcon
                              style={{
                                fontSize: "20px",
                                color: savedisHovered ? "#fff" : "#fe6f35",
                                transition: "color 0.3s ease",
                              }}
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                    {videos && videos.notes ? (
                      <a href={videos.notes} className="btn btn-primary btn-sm">
                        Download Notes
                      </a>
                    ) : null}

                  </div>
                ) : null}

                {read ? <div className="container-fluid mt-3"></div> : null}
              </div>
            </div>

            {courseId.course_id && courseId.video_id ? (
              <div className="d-block d-lg-none">
                <ClassNotes
                  currentVideoTitle={videos ? videos.class_title : ""}
                  batchId={batchid}
                  courseId={courseId.course_id ? courseId.course_id : ""}
                  videoId={courseId.video_id && courseId.video_id ? courseId.video_id : ""}
                />
              </div>
            ) : (
              <></>
            )}
          </div>

          <div className={`col-12 px-sm-3 pb-3 suggestions ${cinematicMode ? 'mt-4' : 'col-lg-4 col-md-12 col-sm-12'}`}>
            <div className="card shadow d-flex flex-column border-0 h-100">
              <div className="bg-dark rounded-top p-3 border-bottom d-flex justify-content-between align-items-center">
                <h5 className="text-light m-0 fw-bold ">Class Recordings</h5>
                <button
                  className="btn btn-sm btn-outline-success bg-white fw-semibold"
                  onClick={() => setSavedVideosModal(true)}
                  title="View Saved Videos"
                >{
                    <style>
                      {`
                      .btn:hover,
                      .btn:active,
                      .btn:focus {
                        background-color: #54b385 !important;
                        border-color: #54b385 !important;
                        color: #fff !important;
                      }
                    `}
                    </style>
                  }
                  <BookmarkIcon
                    style={{
                      fontSize: "20px",
                    }}
                    className="text-gradient3 test-success"
                  ></BookmarkIcon>{"View Saved Videos "}

                </button>
              </div>


              <div className="flex-grow-1 overflow-auto video-suggestions">
                <div className="border-bottom d-none d-lg-block">{notesDis ? <>
                  <div className="d-flex align-items-center p-1 bg-white video-suggestion-box">
                    <h4 className="ps-3 fw-bold">Notes</h4>
                    <button className="btn btn-siloconMinds-orng ms-auto py-1 px-2" onClick={() => setNotesDis(!notesDis)}><ClearIcon /></button>
                  </div>
                  {courseId.course_id && courseId.video_id ? (
                    <div>
                      <ClassNotes
                        currentVideoTitle={videos ? videos.class_title : ""}
                        batchId={batchid}
                        courseId={courseId.course_id ? courseId.course_id : ""}
                        videoId={courseId.video_id && courseId.video_id ? courseId.video_id : ""}
                      />
                    </div>
                  ) : (
                    <></>
                  )}</> : <div className="d-flex align-items-center p-1  bg-white video-suggestion-box">
                  <h4 className="ps-3 fw-bold">Notes</h4>
                  <button className="btn btn-siloconMinds-orng ms-auto py-1 px-2" onClick={() => setNotesDis(!notesDis)}><MenuIcon /></button>
                </div>} </div>

                {previousclasses ? (
                  previousclasses.map((topic, index) => (
                    <div
                      topic={topic.id}
                      id={index}
                      className={
                        topic.id === videoid
                          ? "d-flex flex-column p-3 border-bottom  bg-white border-success border-2 shadow-sm video-suggestion-box"
                          : "d-flex flex-column p-3 border-bottom  bg-white video-suggestion-box"
                      }
                      key={index}

                    >
                      {
                        <style>
                          {`
                      .video-suggestion-box::hover {
                        background-color: #e4e9f2;
                      } 
                      .video-suggestion-box {
                        transition: background-color 0.3s ease;
                      }
                    `}
                        </style>
                      }
                      <div Name="d-flex justify-content-between align-items-start">
                        <div>
                          <Link
                            to={`/recordings/${courseurl}/${batchid}/${topic.id}`}
                            className="text-decoration-none"
                          >
                            <h6 className="fw-bold text-dark mb-1">{topic.class_title}</h6>
                          </Link>
                          {topic && topic.class_description !== "null" ? (
                            <p className="sm-12 truncate truncate2 mb-2 ">

                              {topic.class_description}

                            </p>
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>

                      <div className="d-flex justify-content-between align-items-center" >
                        <h6 className="text small">
                          {dateFormat(topic.class_starts, "m/d/yyyy")}
                        </h6>
                        <div className="d-flex align-items-center justify-content-end gap-2">
                          {

                            savedVideos && checkSavedVideos(topic.id) ? (
                              <button
                                onClick={() => deleteSavedVideo(topic.id)}

                                style={{
                                  width: "40px",
                                  height: "40px",
                                  borderRadius: "50%",
                                  border: "1px solid rgb(146, 154, 160)",
                                  backgroundColor: "f58752",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  padding: "0",
                                  cursor: "pointer",
                                  transition: "background-color 0.3s ease",
                                }}
                              >
                                <BookmarkRemoveIcon
                                  style={{
                                    fontSize: "18px",
                                    color: "#fff",
                                    transition: "color 0.3s ease",
                                  }}
                                />
                              </button>) : (
                              <button
                                onClick={() => { saveVideo(topic); setHoveredDownloadIndex(topic.id) }}
                                onMouseEnter={() => setHoveredDownloadIndex(topic.id)}
                                onMouseLeave={() => setHoveredDownloadIndex(false)}
                                style={{
                                  width: "36px",
                                  height: "36px",
                                  borderRadius: "50%",
                                  border: "1px solid #d1d5db",
                                  backgroundColor: hoveredDownloadIndex === topic.id ? "#111827" : "#f9fafb",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  padding: 0,
                                  transition: "all 0.3s",
                                  boxShadow: hoveredDownloadIndex === topic.id ? "0 2px 8px rgba(0,0,0,0.08)" : "none"
                                }}
                              >
                                {submitting && downloadProgress[topic.id] !== undefined && downloadProgress[topic.id] !== null ? (
                                  <span
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: "bold",
                                      color: "#fe6f35",
                                    }}
                                    className="text-success"
                                  >
                                    {downloadProgress[topic.id]}%
                                  </span>
                                ) : (
                                  <DownloadIcon
                                    style={{
                                      color: hoveredDownloadIndex === topic.id ? "#f9fafb" : "#111827",
                                      fontSize: "20px",
                                      transition: "color 0.3s"
                                    }}
                                  />
                                )}
                              </button>)}

                          <button
                            onClick={() => {
                              setpath(
                                `${ENDPOINT}recordings/${courseurl}/${batchid}/${topic.id}`
                              );
                              setsharemodal(true);
                            }}
                            onMouseEnter={() => setHoveredShareIndex(index)}
                            onMouseLeave={() => setHoveredShareIndex(null)}
                            style={{
                              width: "36px",
                              height: "36px",
                              borderRadius: "50%",
                              border: "1px solid #f58752",
                              backgroundColor:
                                hoveredShareIndex === index ? "#f58752" : "transparent",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              padding: 0,
                              transition: "all 0.3s ease",
                            }}
                          >
                            <ShareIcon
                              style={{
                                fontSize: "18px",
                                color: hoveredShareIndex === index ? "#fff" : "#f58752",
                                transition: "color 0.3s ease",
                              }}
                            />
                          </button>

                          <button
                            onClick={() => {
                              setclassid(topic.id);
                              setmodal(true);
                            }}
                            onMouseEnter={() => setHoveredFeedbackIndex(index)}
                            onMouseLeave={() => setHoveredFeedbackIndex(null)}
                            style={{
                              width: "36px",
                              height: "36px",
                              borderRadius: "50%",
                              border: "1px solid #f58752",
                              backgroundColor:
                                hoveredFeedbackIndex === index ? "#f58752" : "transparent",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              padding: 0,
                              transition: "all 0.3s ease",
                            }}
                          >
                            <RateReviewIcon
                              style={{
                                fontSize: "18px",
                                color: hoveredFeedbackIndex === index ? "#fff" : "#f58752",
                                transition: "color 0.3s ease",
                              }}
                            />
                          </button>
                        </div>
                      </div>


                    </div>
                  ))
                ) : (
                  <div className="w-100">
                    {loading ? (
                      <>
                        {[...Array(5)].map((_, i) => (
                          <Skeleton
                            key={i}
                            variant="rectangular"
                            height={100}
                            className="mb-2 w-100"
                          />
                        ))}
                      </>
                    ) : (
                      <div className="p-2">
                        <p>No previous classes found</p>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Recordings;
